<template>
  <div class="block">
    <kst-number-with-date input-mode
      :catalog="Catalog"
      :data="userData"
      autoNumberField="IsAutoNumber"
      dateField="DepartureDate"
      numberField="LogisticsNumber"
    />

    <kst-output control-off status-off
      field="ClientID" :data="userData" :catalog="Catalog"
    >
      <template #left>
        <kst-output addons floating-label
          field="ClientAlias" :data="userData" :catalog="Catalog"
        />
      </template>
      <template #default>
        <kst-output addons expanded floating-label
          field="Client" :data="userData" :catalog="Catalog"
        />
      </template>
    </kst-output>

    <kst-input field="VehicleIDNumber" :data="userData" :catalog="Catalog"/>
    <kst-input field="Destination" :data="userData" :catalog="Catalog"/>
    <kst-input field="ShipmentFee" :data="userData" :catalog="Catalog"/>
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
    <kst-input
      field="Status" :data="userData" :catalog="Catalog"
      :options="statusOptions"
    />
    <!-- @input="handleStatus" -->
    <kst-output status-off control-off
      field="WarehouseID" :data="userData" :catalog="Catalog"
    />
  </div>
</template>

<script>
import Catalog from "../DlvCatalog.js";
import Model from "../DlvModel.js";

export default {
  props: {
    userData: Object
  },
  computed: {
    statusOptions() {
      return Model.New.createStatusOptions();
    }
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>